export default __webpack_public_path__ + "static/web-development-00f24891b0501f2c6a8430aa05262c02.webp";